import React, { useEffect, useState, useCallback } from 'react';
import {
  Typography,
  Box,
  CircularProgress,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Chip,
} from '@mui/material';
import { useAuth } from '../components/AuthContext.tsx';
import { authenticatedApiCall } from '../api.ts';
import { format } from 'date-fns';
import frLocale from 'date-fns/locale/fr';

interface HistoryEntry {
  id: number;
  timestamp: string;
  action: 'created' | 'deleted';
  user_name: string;
  actor_name: string;
  spot_id: number;
}

function HistoryPage() {
  const { token, isAdmin } = useAuth();
  const [history, setHistory] = useState<HistoryEntry[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchHistory = useCallback(async () => {
    try {
      setLoading(true);
      const data = await authenticatedApiCall('GET', '/assignments/history/', token);
      setHistory(data);
    } catch (err: any) {
      setError(err.message || "Échec de la récupération de l'historique");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    if (isAdmin) {
      fetchHistory();
    }
  }, [isAdmin, fetchHistory]);

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom>
        Historique des Réservations
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date et Heure</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Utilisateur concerné</TableCell>
              <TableCell>Place</TableCell>
              <TableCell>Action effectuée par</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {history.map((entry) => (
              <TableRow key={entry.id}>
                <TableCell>{format(new Date(entry.timestamp), 'Pp', { locale: frLocale })}</TableCell>
                <TableCell>
                  <Chip label={entry.action === 'created' ? 'Réservé' : 'Annulé'} color={entry.action === 'created' ? 'success' : 'error'} />
                </TableCell>
                <TableCell>{entry.user_name}</TableCell>
                <TableCell>{entry.spot_id}</TableCell>
                <TableCell>{entry.actor_name}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default HistoryPage;